import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import Paper from "@material-ui/core/es/Paper";
import Grow from "@material-ui/core/es/Grow";
import List from "@material-ui/core/es/List";
import ListSubheader from "@material-ui/core/es/ListSubheader";
import ListItem from "@material-ui/core/es/ListItem";
import ListItemText from "@material-ui/core/es/ListItemText";
import LabelAndText from "../../../components/common/LabelAndText";
import Avatar from "@material-ui/core/es/Avatar";
import Collapse from "@material-ui/core/es/Collapse";
import ExpansionPanel from "@material-ui/core/es/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/es/ExpansionPanelSummary";
import Typography from "@material-ui/core/es/Typography";
import ExpansionPanelDetails from "@material-ui/core/es/ExpansionPanelDetails";
import Grid from "@material-ui/core/es/Grid";
import {MdExpandMore} from "react-icons/md";


class RtscInfo extends Component {

    state = {
        openedGroup: null
    };

    toggleGroupCollapse = (index) => {
        this.setState({openedGroup: index === this.state.openedGroup ? null : index})
    };

    renderContactsList = (list, header) => {
        const {classes} = this.props;
        list = list.map(c => c.split('@')[0].replace('\\40', '@'));
        return (
            <List className={classes.contactsList} subheader={<li/>}>
                {header && <ListSubheader>{header}</ListSubheader>}
                {list.length > 0 ? list.map((item, index) => (
                        <ListItem divider={!!header} key={item}>
                            <ListItemText primary={item}/>
                        </ListItem>
                    )) :
                    <ListItem>
                        <ListItemText secondary="No contacts found"/>
                    </ListItem>}
            </List>
        );
    };

    renderGroupsList = () => {
        const {classes, account} = this.props;
        const list = account.pii.rtsc.groups;
        if(list && list.length > 0)
        return (
            <List className={classes.groupsList} subheader={<li/>}>
                <ListSubheader>Groups</ListSubheader>
                {list.map((item, index) => {
                        const fields = item.nodeconfig.form.fields.reduce((acc, item) => {
                            acc[item.name.split('#')[1]] = item.value;
                            return acc
                        }, {});
                        const members = item.affiliations.a_list.map(a => a.jid);
                        const isOpened = this.state.openedGroup === index;
                        return (
                            <ListItem divider={index < list.length-1} key={item.jid} style={{padding: 0}}>
                                <ExpansionPanel expanded={isOpened} className={classes.expPanel}
                                                onChange={() => this.toggleGroupCollapse(index)}>

                                    <ExpansionPanelSummary expandIcon={<MdExpandMore/>}>
                                        <Typography className={classes.heading}>{fields.title || 'Unnamed'}</Typography>
                                    </ExpansionPanelSummary>

                                    <ExpansionPanelDetails>
                                        <Grid container justify='center' style={{opacity: isOpened ? 1 : 0}}>
                                            <Grid item xs={12} style={{backgroundColor: 'white'}}>
                                                {fields.img && <LabelAndText label="Image" content={<Avatar src={fields.img}/>}/>}
                                                <LabelAndText label="Created at" content={fields.create_date}/>
                                                <LabelAndText label="Members" content={this.renderContactsList(members)}/>
                                            </Grid>
                                        </Grid>
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                                {/*<ListItemText primary={title} />*/}
                            </ListItem>
                        )
                    })}
            </List>
        );
    };

    render() {
        const {classes, account, timeout, content} = this.props;
        const {rtsc} = account.pii;
        const data = content || rtsc;
        if (!data || (Object.keys(data.profile).length === 0 && data.profile.constructor === Object) && !(data.groups && data.groups.length > 0)) {
            return null
        }
        return (
            <Grow in timeout={timeout || 1000}>
                <Paper className={classes.pageContainer}>
                    {data.profile && (Object.keys(data.profile).length > 0 && data.profile.constructor === Object) &&
                    <ListItem>
                        {data.profile.photo && <Avatar src={data.profile.photo} />}
                        <ListItemText primary={data.profile.name}
                                      secondary={data.profile.email || data.profile.email_address} />
                    </ListItem>}
                    <div className={classes.tableWrapper}>
                        {/*{account.pii.rtsc.contacts && this.renderContactsList(account.pii.rtsc.contacts, "Contacts")}*/}
                        {this.renderGroupsList()}
                    </div>
                </Paper>
            </Grow>
        );
    }
}

function mapStateToProps({account}) {
    return ({account})
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(RtscInfo);



// WEBPACK FOOTER //
// ./src/containers/delete-account/components/RtscInfo.js